<template>
  <v-btn
    v-bind="$attrs"
    :variant="computedVariant"
    :color="computedColor"
    :class="buttonClasses"
  >
    <slot />
  </v-btn>
</template>

<script setup lang="ts">
import { computed } from 'vue'

export interface DsButtonProps {
  /**
   * Variant del botón basado en el sistema de diseño
   * @default 'primary'
   */
  dsVariant?: 'primary' | 'secondary' | 'ghost' | 'text'
}

const props = withDefaults(defineProps<DsButtonProps>(), {
  dsVariant: 'primary'
})

// Mapeo de variantes del sistema de diseño a variantes de Vuetify
const computedVariant = computed(() => {
  switch (props.dsVariant) {
    case 'primary':
      return 'elevated'
    case 'secondary':
      return 'elevated'
    case 'ghost':
      return 'outlined'
    case 'text':
      return 'text'
    default:
      return 'elevated'
  }
})

// Mapeo de colores según la variante del sistema de diseño
const computedColor = computed(() => {
  switch (props.dsVariant) {
    case 'primary':
      return 'primary'
    case 'secondary':
      return 'accent'
    case 'ghost':
      return 'primary'
    case 'text':
      return 'primary'
    default:
      return 'primary'
  }
})

// Clases adicionales según la variante
const buttonClasses = computed(() => {
  return {
    'ds-button': true,
    [`ds-button--${props.dsVariant}`]: true
  }
})
</script>

<style scoped lang="scss">
.ds-button {
  // Estilos base del botón usando tokens del sistema de diseño
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.025em;

  &--primary {
    // El estilo primary ya está definido por Vuetify con nuestros tokens
  }

  &--secondary {
    // El estilo secondary (accent) ya está definido por Vuetify
  }

  &--ghost {
    // Botón outlined con estilo fantasma
    background-color: transparent;
  }

  &--text {
    // Botón de texto sin fondo
  }
}
</style>
